/**
 * Centralized theme constants for athlete-flow.
 * The light palette; the class names still say 'dark' where older screens import them.
 */

// ─── Color Scheme ──────────────────────────────────────────────────────────

export const COLORS = {
  // Lime accent — primary action color
  lime: {
    solid: '#C0FD72',
    hover: '#b0ef62',
  },
  // Text colors for dark theme
  text: {
    primary: 'text-foreground',
    secondary: 'text-gray-700',
    muted: 'text-gray-600',
    mutedHover: 'text-gray-700',
  },
  // Border colors for dark theme
  border: {
    subtle: 'border-foreground/5',
    light: 'border-foreground/10',
    lighter: 'border-foreground/15',
    lightest: 'border-foreground/20',
  },
  // Background colors for dark theme
  bg: {
    card: 'bg-muted',
    cardSubtle: 'bg-card',
    hover: 'bg-muted',
    hoverLight: 'bg-card',
  },
}

// ─── Button Class Presets ─────────────────────────────────────────────────

export const BUTTON_CLASSES = {
  // Primary action button — lime
  lime: 'bg-[#C0FD72] text-black hover:bg-[#b0ef62] font-semibold',

  // Secondary action button — dark outline
  darkOutline:
    'border border-foreground/15 text-gray-700 bg-transparent hover:bg-foreground/5 hover:text-foreground',

  // Subtle secondary button
  darkGhost: 'text-gray-700 hover:text-foreground hover:bg-foreground/5',
}

// ─── Card Class Presets ──────────────────────────────────────────────────

export const CARD_CLASSES = {
  // Dark card — use with cn() when a plain <div> is needed instead of <Card>
  dark: 'bg-muted backdrop-blur-xs border border-foreground/5 rounded-3xl rounded-bl-none shadow-lg',
}

// ─── Input Class Presets ─────────────────────────────────────────────────

export const INPUT_CLASSES = {
  // Dark input field
  dark: 'bg-card border-foreground/10 text-foreground',
}

// ─── Dialog Class Presets ────────────────────────────────────────────────

export const DIALOG_CLASSES = {
  // Dark content background
  dark: 'bg-card border-foreground/10 text-foreground',
}
